import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VCard,{staticClass:"pa-1",attrs:{"flat":""}},[_c(VToolbar,{attrs:{"flat":"","color":"#FFF","short":""}},[_c(VToolbarTitle,[_vm._v("Configurações do Sistema")])],1),_c(VTabs,{attrs:{"centered":""}},[_c(VTab,[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-link-variant")]),_vm._v("\n                Instância Parceira\n            ")],1),_c(VTabItem,{staticClass:"ma-0"},[_c(VCard,{attrs:{"flat":""}},[_c(VCardText,{staticClass:"pa-0"},[_c('cfg-instancia-parceira')],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }